import { useCallback, useEffect, useMemo, useState } from 'react'
import { queryPlaces } from '@user/Root'
import { HereResult } from '@user/store/services/hereGeoCoder'
import * as _ from 'lodash'
import { useLocalizationEnabled } from '@user/store/tenantFeatures/hooks/useLocalizationEnabled'

export const useQueryPlaces = () => {
  const [query, setQuery] = useState<string>()
  const [results, setResult] = useState<HereResult[]>([])
  const localizationEnabled = useLocalizationEnabled()

  const execute = useCallback((query: string) => {
    const q = query.trim()
    if (q != '' && q.length > 2) {
      setQuery(q)
    } else {
      setResult([])
    }
  }, [])

  const fetch = useMemo(
    () =>
      _.debounce(
        (
          search: string,
          geolocation: string,
          callback: (results?: HereResult[]) => void,
        ) => queryPlaces(search, geolocation, callback, localizationEnabled),
        500,
      ),
    [localizationEnabled],
  )

  useEffect(() => {
    let mounted = true

    if (!!query) {
      fetch(query, '', (results?: HereResult[]) => {
        if (mounted) {
          setResult(results ?? [])
          setQuery(undefined)
        }
      })
    }

    return () => {
      mounted = false
    }
  }, [fetch, query])

  return { results, execute }
}
